module.exports = __webpack_public_path__ + "assets/img/DS-corridors (1).af2b7992.jpg";